<template>
  <!-- 审批节点 -->
  <div class="">
    <el-form  label-width="2.4rem">
      <el-form-item label="节点名称">
        <el-input v-model="nodeInfo.nodeName"/>
      </el-form-item>
      <el-form-item label="签署人员为" v-if="params.checkType !== 3">
        <el-select v-model="params.employeeType">
          <el-option label="指定人员" :value="1"/>
          <el-option label="单据提交人员部门负责人" :value="2"/>
        </el-select>
      </el-form-item>
      <el-form-item label="签署人员" v-if="params.employeeType === 1 && params.checkType !== 3">
        <employee-select-sort ref="employeeSelectSort" v-model="params.employeeRange"/>
      </el-form-item>
      <el-form-item label="签署方式">
        <el-radio-group v-model="params.checkType">
          <el-radio-button :value="1">或签</el-radio-button>
          <el-radio-button :value="2">会签</el-radio-button>
          <el-radio-button :value="4">并签</el-radio-button>
          <el-radio-button :value="3">自动通过</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <span class="info-check-type" v-if="params.checkType === 1">所有人员中只需要有一个签署通过</span>
        <span class="info-check-type" v-if="params.checkType === 2">所有人员需要依次签署通过</span>
        <span class="info-check-type" v-if="params.checkType === 3">直接通过</span>
        <span class="info-check-type" v-if="params.checkType === 4">所有人员都需要签署通过，但不限次序</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import EmployeeSelectSort from "@/components/h5/data/EmployeeSelectSort.vue";
import VueDraggable from "vuedraggable/src/vuedraggable";
import customerComponentCheck from "./CustomerComponentCheck";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
export default {
  props: {
    data: {
      default: () => {}
    }
  },
  watch: {
    data: {
      handler() {
        this.init();
      }
    }
  },
  name: "",
  components: {
    TableButton,
    YqTableColumn,
    YqTable,
    EmployeeSelectSort, VueDraggable,
  },
  data() {
    return {
      nodeInfo: {},
      // 审批配置信息
      params: {
        employeeType: 1, // 审批人员，1指定 2提交单据的部门负责人
        checkType: "", // 签署方式 1 或签，2 会签 3 直接通过
        employeeRange: "", // 审批人员, 有序的职员
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 节点相关信息
      this.nodeInfo = {...this.data};
      if (this.data.businessParams) {
        this.params = JSON.parse(this.data.businessParams);
      } else {
        this.params = {
          employeeType: 1, // 审批人员，1指定 2提交单据的部门负责人
          checkType: "", // 签署方式 1 或签，2 会签 3 直接通过
          employeeRange: "", // 审批人员
        }
      }
    },
    checkData() {

    },
    // 返回数据，并进行验证
    getData() {
      let data = {...this.nodeInfo};
      if (this.params.employeeType === 1 && this.$refs.employeeSelectSort) {
        let employees = this.$refs.employeeSelectSort.getEmployeeList();
        if (this.params.employeeRange) {
          let ems = [];
          for (let i = 0; i < employees.length; i++) {
            if (i < 3) {
              ems.push(employees[i].employeeName);
            } else {
              ems.push("等")
              break;
            }
          }
          data.message = "审批人：" + ems.join(",");
        }
      } else if (this.params.employeeType === 2){
        // 按部门负责人
        data.message = "审批人：单据提交人员的部门负责人";
      }
      if (this.params.checkType === 1) {
        data.message += "<br/>签署方式：任意一人";
      }else if (this.params.checkType === 2) {
        data.message += "<br/>签署方式：依次通过";
      } else if (this.params.checkType === 4) {
        data.message += "<br/>签署方式：无次序签署";
      } else if (this.params.checkType === 3) {
        data.message = "签署方式：自动通过";
      }
      data.businessParams = JSON.stringify(this.params);
      data.properties = {
        businessParams: data.businessParams
      };
      let message = customerComponentCheck.checkNodeValid(data);
      if (data.properties.invalid && message) {
        // 无效节点
        this.$message.error(message);
        throw new Error(message);
      }
      return data;
    },
  }
};
</script>

<style lang="scss" scoped>
.info-check-type{
  color: var(--yq-font-color-desc);
}
</style>